var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigheValueItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.30162 1.60184C1.02652 1.60184 0 3.90346 0 3.90346C0 3.90346 1.02652 6.20508 2.30162 6.20508H14.0974C13.7044 6.3401 13.3609 6.64255 13.1864 7.02033L8.58312 16.2268C8.21548 17.0106 8.67151 18.0669 9.49418 18.3366L12.2753 19.2956V23.0358C12.2754 23.8392 13.0063 24.5702 13.8097 24.5702H15.3441C16.1475 24.5702 16.8785 23.8392 16.8785 23.0358V19.2956L19.6597 18.3366C20.4823 18.0669 20.9384 17.0106 20.5707 16.2268L15.9675 7.02033C15.7647 6.59775 15.3682 6.30727 14.9126 6.20508H26.8522C28.1273 6.20508 29.1538 3.90346 29.1538 3.90346C29.1538 3.90346 28.1273 1.60184 26.8522 1.60184H2.30162Z",
    fill: "#5161CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2879 4.62302C13.8119 4.71508 13.3884 5.04605 13.1851 5.48612L8.58182 14.6926C8.21417 15.4764 8.6702 16.5327 9.49288 16.8024L12.274 17.7614V21.5016C12.2741 22.305 13.005 23.036 13.8084 23.036H15.3428C16.1462 23.036 16.8772 22.305 16.8772 21.5016V17.7614L19.6584 16.8024C20.481 16.5327 20.9371 15.4764 20.5694 14.6926L15.9662 5.48612C15.6957 4.92269 15.0537 4.56149 14.4318 4.62302C14.3839 4.62148 14.3358 4.62148 14.2879 4.62302Z",
    fill: "#5161CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5757 6.15744L9.97241 15.3639L13.8084 16.6585V21.5016H15.3429V16.6585L19.1789 15.3639L14.5757 6.15744Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.20837L0 2.47125C0 3.69099 1.03047 4.67978 2.30162 4.67978L26.8522 4.67978C28.1233 4.67978 29.1538 3.69099 29.1538 2.47125V2.20837C29.1538 0.988622 28.1233 -0.000162125 26.8522 -0.000162125L2.30162 -0.000162125C1.03047 -0.000162125 0 0.988622 0 2.20837Z",
    fill: "#5161CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53516 3.14575V1.61134L27.6201 1.61134V3.14575L1.53516 3.14575Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigheValueItemIcon);
export default __webpack_public_path__ + "static/media/higheValueItemIcon.3597164dba2173c3e89536aecdbd6f93.svg";
export { ForwardRef as ReactComponent };